import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface MakeupTargetClass {
  _id: string;
  title: string;
  days: string[];
  startDate: string;
  endDate: string;
  startTime?: string;
  endTime?: string;
  session: string;
  acceptsMakeups: boolean;
}

export const getMakeupTargetsAPI = async (params: {
  studentId: string;
  sessionId: string;
  sourceEnrollmentId?: string;
}) => {
  const response = await baseAPI.get<MakeupTargetClass[]>('/makeup/targets', {
    params,
  });
  return response.data;
};

export const useGetMakeupTargets = (
  params: {
    studentId: string;
    sessionId: string;
    sourceEnrollmentId?: string;
  },
  enabled = true,
) => {
  return useQuery({
    queryKey: [
      KEYS.MAKEUP_TARGETS,
      params.studentId,
      params.sessionId,
      params.sourceEnrollmentId ?? null,
    ],
    queryFn: () => getMakeupTargetsAPI(params),
    enabled:
      enabled &&
      !!params.studentId &&
      !!params.sessionId &&
      !!params.sourceEnrollmentId,
  });
};
